import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";


export default class PageDefault extends PageCommon {
  constructor() {
    super();
    window.HomeRef = this
  }
  init($data) {
    super.init($data);
    console.log($data)
    this.staff = $data.staffList;
    this.showPreloader(false);
    Pqp.trace("PageDefault - Hello world");

    const swiper = new Swiper('.js-swiper-staff', {
      slidesPerView: 1,
      spaceBetween: 10,
      grabCursor: true,
      loop: true,

      breakpoints: {
        992: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1400: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
        clickable: true,
      },
    })
    let scrollpos = window.scrollY

    const nav = document.querySelector('nav')
    const scrollChange = 100

    const add_class_on_scroll = () => nav.classList.add('bg-main')
    const remove_class_on_scroll = () => nav.classList.remove('bg-main')

    window.addEventListener('scroll', function () {
      scrollpos = window.scrollY

      if (scrollpos >= scrollChange) {
        add_class_on_scroll()
      } else {
        remove_class_on_scroll()
      }
    })
    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    } catch (error) {
      console.log(error);
    }
  }

  get isHomepage() {
    return true;
  }

  fillModal(uid) {

    let staffer;
    for (let x = 0; x < this.staff.length; x++) {
      if (this.staff[x].Uid === uid) {
        staffer = this.staff[x];
        break;

      }
    }

    console.log(staffer)
    let mc = jQuery("#staffModal");
    jQuery(".js-foto", mc).attr("src", staffer.Image)
    jQuery(".js-nome", mc).text(staffer.DisplayName)
    jQuery(".js-data", mc).text(staffer.DateExtended)
    jQuery(".js-content", mc).html(staffer.Content)

  }

}

